import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    termination: [],
}

const termSlice = createSlice({
    name: 'termination',
    initialState,
    reducers: {
        addTerm: (state, action)=>{
            state.termination = action.payload
        },
    }
})

export const handleTermination= (state)=>{
    return dispatch => {
        dispatch(termSlice.actions.addTerm(state))
    }
}


export default termSlice.reducer